import { useTranslation } from '@zurich/common/hooks';
import { Stack, Typography } from '@zurich/ui/atoms';
import { styled } from '@zurich/ui/legacy/utils';
import type { AutoArea } from '~/lib/types';
import {
  DamageDescriptionField,
  DamagedPartSelect,
  TypeOfDamageSelect,
} from './';

type DamageFieldsProps = {
  id: string;
  step: AutoArea;
};

export function DamageFields({ id, step }: DamageFieldsProps) {
  const { t } = useTranslation();

  return (
    <StackStyled gap={3}>
      <Typography variant="body2 regular" color="darkBlue">
        {t('vsga:damagePhoto.bodyDescription')}
      </Typography>
      <DamagedPartSelect id={id} step={step} />
      <TypeOfDamageSelect id={id} step={step} />
      <DamageDescriptionField id={id} />
    </StackStyled>
  );
}

const StackStyled = styled(Stack)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));
